/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown>, step: NonNullable<unknown> }} Notifications_Case_Step_Changed_TitleInputs */

const en_notifications_case_step_changed_title = /** @type {(inputs: Notifications_Case_Step_Changed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case ${i?.caseNumber} moved to ${i?.step}`)
};

const pt_br2_notifications_case_step_changed_title = /** @type {(inputs: Notifications_Case_Step_Changed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso ${i?.caseNumber} avançou para ${i?.step}`)
};

/**
* | output |
* | --- |
* | "Case {caseNumber} moved to {step}" |
*
* @param {Notifications_Case_Step_Changed_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_case_step_changed_title = /** @type {((inputs: Notifications_Case_Step_Changed_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Case_Step_Changed_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_case_step_changed_title(inputs)
	return pt_br2_notifications_case_step_changed_title(inputs)
});